import { render, staticRenderFns } from "./SuperSale.vue?vue&type=template&id=fa8945ac&"
import script from "./SuperSale.vue?vue&type=script&lang=js&"
export * from "./SuperSale.vue?vue&type=script&lang=js&"
import style0 from "./SuperSale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports